import { render, staticRenderFns } from "./EditProductSpendLimitDialog.vue?vue&type=template&id=93247788&"
import script from "./EditProductSpendLimitDialog.vue?vue&type=script&lang=js&"
export * from "./EditProductSpendLimitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports